const INITIAL_STATE = {
  data: [],
  isFetching: false,
  error: false,
};

const maximetroReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "MAXIMETRO_START":
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case "MAXIMETRO_SUCCESS":
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case "MAXIMETRO_FAILURE":
      return {
        ...state,
        isFetching: false,
        error: true,
      };
    case "logoutInfoMaximetro":
      return {
        ...INITIAL_STATE
      };
    default:
      return state;
  }
};

export default maximetroReducer;

export const logoutInfoMaximetro = () => ({ type: "logoutInfoMaximetro" });
export const maximetroStart = () => ({ type: "MAXIMETRO_START" });
export const maximetroSuccess = (data) => ({ type: "MAXIMETRO_SUCCESS", payload: data });
export const maximetroFailure = () => ({ type: "MAXIMETRO_FAILURE" }); 